import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { addData, getList } from "../../helpers/fackBackend_Helper";

function* getInventoryDataResponse() {
  try {
    const response = yield call(getList, "/makeInvoice");
    if (response.response.Status) {
      yield put(actions.getSimPinInventorySuccess(response.response.Data));
    } else {
      yield put(actions.getSimPinInventoryFailed(response.response.Message));
    }
  } catch (error) {
    yield put(actions.getSimPinInventoryFailed(error));
  }
}

function* addSimPinInventoryResponse({ payload: { data, searchData } }) {
  try {
    const response = yield call(addData, "/addSIMPINInventory", data);
    if (response.Status) {
      yield put(actions.addSimPinInventorySuccess(response.Message));
      yield put(actions.getSimPinInventoryList(searchData));
    } else {
      yield put(actions.addSimPinInventoryFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.addSimPinInventoryFailed(error));
  }
}

function* getSimPinInventoryListResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/simPininventoryDetails", data);
    if (response.response.Status) {
      yield put(actions.getSimPinInventoryListSuccess(response.response.Data));
    } else {
      yield put(
        actions.getSimPinInventoryListFailed(response.response.Message),
      );
    }
  } catch (error) {
    yield put(actions.getSimPinInventoryListFailed(error));
  }
}

function* getSimPinInventoryViewDetailsResponse({ simPinId }) {
  try {
    const response = yield call(getList, "/simPininventoryViewDetails/" + simPinId);
    if (response.response.Status) {
      yield put(actions.getSimPinInventoryViewDetailsSuccess(response.response.Data));
    } else {
      yield put(
        actions.getSimPinInventoryViewDetailsFailed(response.response.Message),
      );
    }
  } catch (error) {
    yield put(actions.getSimPinInventoryViewDetailsFailed(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_SIM_PIN_INVENTORY_DETAILS, getInventoryDataResponse),
  ]);
  yield all([
    takeEvery(actions.ADD_SIM_PIN_INVENTORY, addSimPinInventoryResponse),
  ]);
  yield all([
    takeEvery(
      actions.GET_SIM_PIN_INVENTORY_LIST,
      getSimPinInventoryListResponse,
    ),
  ]);
yield all([
    takeEvery(
      actions.GET_SIM_PIN_INVENTORY_VIEW_DETAILS,
      getSimPinInventoryViewDetailsResponse,
    ),
  ]);
}
